export const ADDRESS = {
  street1: '166 Liverpool Street',
  phone: '03 6411 6705',
  mobile: '0407 738 676',
  email: 'admin@monklawyers.com.au',
};
